import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import injectSheet from 'react-jss';
import Radio from '@eg/elements/Radio';
import { contactDataProps } from '../../models/panels';
import withMultiFieldValidation from '../../hocs/withMultiFieldValidation';
import ErgoMaskedText from '../ErgoMaskedText';
import ErgoInputText from '../../components/ErgoInputText';
import { maskTypes, formatCharactersToMask } from '../../helpers/masks';
import styles from './styles.jss';

class ContactDataWithoutEmail extends React.PureComponent {
  constructor(props) {
    super();
    this.state = {
      who: props.data.who,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  getErrorMessage(validationProps) {
    if (!validationProps || !validationProps.error) {
      return '';
    }

    const { who } = this.state;

    let customError = '';
    if (who === contactDataProps.optionTypes.COMPANY) {
      customError = validationProps.error.company;
    } else {
      customError = validationProps.error.person;
    }

    return customError || validationProps.error;
  }

  handleChange = e => {
    const { getValidationProps } = this.props;
    const { onChange, name } = getValidationProps('who');
    const { value } = e.target;
    const target = {
      name,
      value,
    };
    onChange({ target });
    this.setState({ who: value });
  };

  render() {
    const {
      localePath, getValidationProps, options, classes,
    } = this.props;
    const { t } = this.context;
    const { who } = this.state;
    const { name } = getValidationProps('who');
    const inputs = {
      firstName: { size: 6 },
      lastName: { size: 6 },
      phoneNumber: {
        size: 6,
        mask: maskTypes.PHONE_NUMBER,
        formatCharacters: formatCharactersToMask.PHONE_NUMBER,
      },
    };

    return (
      <div className="esc_grid">
        <div className="esc_grid__wrapper">
          <div className={`esc_col esc_col-12 ${classes.options}`}>
            <div>
              {t(`${localePath}.labels.head`)}
            </div>
            {options.map(option => (
              <Radio
                className={classes.radioButton}
                onChange={this.handleChange}
                name={name}
                key={option}
                value={option}
                label={t(`${localePath}.labels.${option}`)}
                checked={who === option}
              />
            ))}
          </div>
          {Object.keys(inputs).map(inputName => {
            const input = inputs[inputName];
            const isCompany = who === contactDataProps.optionTypes.COMPANY
              ? contactDataProps.optionTypes.COMPANY : 'person';
            const inputPlaceholder = t(`${localePath}.placeholders.${isCompany}.${inputName}`);
            const inputDescription = t(`${localePath}.descriptions.${isCompany}.${inputName}`);
            const validationProps = getValidationProps(inputName);
            const error = this.getErrorMessage(validationProps);
            const validationPropsWithError = { ...validationProps, error };
            if (input.mask) {
              return (
                <div key={inputName} className={`esc_col esc_col-12 esc_col-s-${input.size}`}>
                  <ErgoMaskedText
                    type="text"
                    placeholder={inputPlaceholder}
                    mask={input.mask}
                    formatCharacters={input.formatCharacters}
                    inputSize={input.size}
                    {...validationPropsWithError}
                  />
                </div>
              );
            }

            return (
              <div key={inputName} className={`esc_col esc_col-12 esc_col-s-${input.size}`}>
                <ErgoInputText
                  {...validationPropsWithError}
                  placeholder={inputPlaceholder}
                  description={inputDescription}
                />
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

ContactDataWithoutEmail.propTypes = contactDataProps.props;

ContactDataWithoutEmail.contextTypes = {
  t: PropTypes.func,
};

ContactDataWithoutEmail.defaultProps = contactDataProps.defaults;

const mapStateToProps = ({ formData }, ownProps) => ({ data: formData[ownProps.pathName][ownProps.name] });

export { ContactDataWithoutEmail as ContactDataWithoutEmailPlain };
export default compose(
  connect(
    mapStateToProps,
    null,
  ),
  injectSheet(styles),
  withMultiFieldValidation,
)(ContactDataWithoutEmail);
